import { render, staticRenderFns } from "./ModalCreateForm.vue?vue&type=template&id=2e3936a2"
import script from "./ModalCreateForm.vue?vue&type=script&lang=ts"
export * from "./ModalCreateForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports